import { combineReducers } from "redux";
import DirectionsReducer from "Containers/Directions/DirectionsReducer";
import { TrailsReducer } from "Containers/Trails";
import {
  StopsReducer,
  CurrentStopReducer,
  PathStopsReducer,
  PersonalizedStopsReducer,
} from "Containers/Stops";
import { SearchOptionsViewReducer, ModulesReducer } from "Containers/CampusMap";
import { DestinationsReducer } from "Containers/Destinations";
import { AudioPlayerReducer } from "Containers/AudioPlayer";
import { MapSwitcherReducer } from "Containers/MapSwitcher";
import { MediaViewerReducer } from "Containers/MediaViewer";
import { SearchAIReducer } from "Containers/SearchAI";
import YouvisitAnalytics from "HOC/YouVisitAnalytics/store";
import Tour from "HOC/TourInitializer/store";
import { AnalyticsReducer } from "../shared/analyticsManager";

export default combineReducers({
  directions: DirectionsReducer,
  trails: TrailsReducer,
  stops: StopsReducer,
  searchOptionsView: SearchOptionsViewReducer,
  destinations: DestinationsReducer,
  pathStops: PathStopsReducer,
  audioPlayer: AudioPlayerReducer,
  analytics: YouvisitAnalytics.reducer,
  analyticsManager: AnalyticsReducer,
  tour: Tour.reducer,
  locationModulesMatrix: ModulesReducer,
  // TODO: This needs to be merged with the StopsReducer
  currentStop: CurrentStopReducer,
  mapSwitcher: MapSwitcherReducer,
  personalizedStops: PersonalizedStopsReducer,
  mediaViewer: MediaViewerReducer,
  searchAI: SearchAIReducer,
});
